<div class="background-img" style="background-image: url('./assets/img/brand/stethoscope.jpg')">
    <div class="filter"></div>
    <div class="container">
        <div class="row">
            <h1 class="title"> &nbsp;404 <br/>
                <p class="error-msg">The page you requested could not be found</p>
            </h1>


        </div>
        <div class="container-cards">
            <div class="row">
                <h5 class="discover-pages text-center">You can discover:</h5>
                <br/><br/><br/>
            </div>

            <div class="row">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="card card-just-text">
                                <div class="card-body text-center">
                                    <div class="card-icon"><a href="/"><i class="fa fa-desktop" aria-hidden="true"></i></a></div>
                                    <p class="card-description">Home</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card card-hover-effect card-just-text">
                                <div class="card-body text-center">
                                    <h4 class="card-icon"><a href="/support"><i class="nc-icon nc-support-17" aria-hidden="true"></i></a></h4>
                                    <p class="card-description">Support</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card card-hover-effect card-just-text">
                                <div class="card-body text-center">
                                    <h4 class="card-icon"><a href="/login"><i class="fa fa-user" aria-hidden="true"></i></a></h4>
                                    <p class="card-description">Login</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card card-hover-effect card-just-text">
                                <div class="card-body text-center">
                                    <h4 class="card-icon"><a href="/info_news"><i class="fa fa-file-text-o" aria-hidden="true"></i></a></h4>
                                    <p class="card-description">News</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
